import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [isReLogin, setIsReLogin] = useState(false);
  const [wasLoggedOut, setWasLoggedOut] = useState(false);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    // Store name separately if it exists in userData
    if (userData.name) {
      localStorage.setItem('name', userData.name); // Store as string, not JSON
    }
    localStorage.setItem('token', userData.token);
    
    // Set re-login flag if user was previously logged out
    if (wasLoggedOut) {
      setIsReLogin(true);
      setWasLoggedOut(false); // Reset the flag
    }
  };

  const logout = () => {
    setUser(null);
    setIsReLogin(false);
    setWasLoggedOut(true); // Mark that user has logged out
    localStorage.removeItem('user');
    localStorage.removeItem('name');
    localStorage.removeItem('token');
  };

  // Reset re-login flag after it's been handled
  const resetReLoginFlag = () => {
    setIsReLogin(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isReLogin, resetReLoginFlag }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};